








import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({ components: {} })
export default class MenuButton extends Vue {
  @Prop()
  title!: string;
  @Prop()
  link!: any;
  @Prop()
  icon!: string;

  onclick() {
    this.$router.push(this.link);
  }
}
